(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/shared/hooks/use-scroll-position.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/shared/hooks/use-scroll-position.js');
"use strict";


const {
  useEffect,
  useRef
} = React;
const useScrollPosition = _ref => {
  let {
    element
  } = _ref;
  const trackSelectors = ['.einstant-ticket-card', '.tickets-einstant-categories-title'];
  const storageKey = 'lobby-scroll-position';
  const isInitialLoad = useRef(false);
  const scrollToPosition = () => {
    if (isInitialLoad.current) {
      const savedPosition = sessionStorage.getItem(storageKey);
      if (savedPosition) {
        const pos = parseInt(savedPosition, 10);
        window.scrollTo(0, pos);
        sessionStorage.removeItem(storageKey);
      } else {
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 0);
      }
      isInitialLoad.current = false;
    }
  };
  const saveScroll = () => {
    var _document$body;
    const lockedY = Math.abs(parseInt(((_document$body = document.body) === null || _document$body === void 0 || (_document$body = _document$body.style) === null || _document$body === void 0 ? void 0 : _document$body.top) || '0', 10)) || 0;
    const y = lockedY || window.pageYOffset || window.scrollY || 0;
    sessionStorage.setItem(storageKey, String(y));
  };
  useEffect(() => {
    isInitialLoad.current = true;
  }, []);
  useEffect(() => {
    const handleElementClick = event => {
      const clickedElement = trackSelectors.find(selector => event.target.closest(selector));
      if (clickedElement) {
        sessionStorage.setItem(storageKey, window.scrollY.toString());
      }
    };
    document.addEventListener('click', handleElementClick);
    return () => {
      document.removeEventListener('click', handleElementClick);
    };
  }, [trackSelectors, storageKey]);
  useEffect(() => {
    if (element.current && element.current.classList.contains('content-visible')) {
      scrollToPosition();
    }
  }, [element.current]);
  return {
    scrollToPosition,
    saveScroll
  };
};
setGlobal('svs.eInstant.shared.hooks.useScrollPosition', useScrollPosition);

 })(window);